import { Redirect, Route } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import { hasToken } from './utils/storage';
export default function AuthRoute(props) {
  console.log(props);
  const Com = props.component;
  return /*#__PURE__*/React.createElement(Route, {
    path: props.path,
    render: () => {
      if (hasToken()) {
        return /*#__PURE__*/React.createElement(Com, null);
      } else {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/login"
        });
      }
    }
  });
}
AuthRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.func.isRequired
};